import { task, TaskGroup } from 'mobx-task'
import { ApprovedTransaction } from '../ApprovedTransaction'

/**
 * View model for an approved transaction.
 */
export class ApprovedTransactionViewModel {
  /**
   * Task group.
   */
  readonly tasks

  /**
   * Constructor.
   */
  constructor(
    public readonly transaction: ApprovedTransaction,
    private _removeDelegate: () => Promise<void>,
  ) {
    this.tasks = TaskGroup<any, any>([this.remove])
  }

  /**
   * Removes the transaction from the payout.
   */
  remove = task.resolved(this._removeDelegate)
}
